import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { useTranslation } from 'react-i18next';
import { Icon } from '~/global/components/icon/Icon';
import { useLocalizedValue } from '@/hooks/useLocalizedValue';
import { useLivePowerSyncQuery } from '~/powersync/hooks/useLivePowerSyncQuery';
import { db } from '@/lib/local-api';
import type {
  SportActivityCategoryRecord,
  SportActivityRecord,
} from '~/powersync/generated/schema';
import { cn } from '@/lib/utils';

export interface SportActivityListItemProps {
  activity: SportActivityRecord;
  onPress?: () => void;
  showBottomBorder?: boolean;
}

export const SportActivityListItem = ({
  activity,
  onPress,
  showBottomBorder,
}: SportActivityListItemProps) => {
  const { t } = useTranslation('workout');

  const localizedName = useLocalizedValue(activity.name);

  const { data: categories } =
    useLivePowerSyncQuery<SportActivityCategoryRecord>(
      db.SportActivity.queries.findCategoryById(activity.categoryId),
      [activity.categoryId],
    );
  const category = categories?.[0];
  const localizedCategory = useLocalizedValue(category?.title);

  const subtitle = [localizedCategory, t('exerciseLibrary.custom')]
    .filter(Boolean)
    .join(' • ');

  return (
    <Pressable
      onPress={onPress}
      className={cn(
        'flex flex-row items-center gap-3.5 px-4 py-3.5',
        showBottomBorder && 'border-b border-border',
      )}
    >
      <View className="items-center justify-center rounded-lg bg-surface-elevated h-11 w-11">
        <Icon name="Dumbbell" size={20} className="text-accent" />
      </View>

      <View className="flex-1 gap-0.5">
        <Text
          className="font-inter-medium text-sm text-text-primary"
          numberOfLines={1}
        >
          {localizedName}
        </Text>
        <Text className="font-inter-regular text-xs text-text-secondary">
          {subtitle}
        </Text>
      </View>

      <Icon name="ChevronRight" size={16} className="text-text-muted" />
    </Pressable>
  );
};
